import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import HelpdeskListing from "./helpdeskListing";
import { getHelpdeskList } from "services/redux/brandActivtion/conductCamp/action";

const mapStateToProps = (state) => ({
  carnivalList: state.ConductCampReducer.helpdeskList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getHelpdeskList,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HelpdeskListing);
